import { Box, Tooltip, Typography, Spacer } from '@telus-uds/components-web'
import { LegalTextRenderer } from '../../../utils/text/TextRenderer'
import { Positioned } from './Styles'
import { PlanSectionDetailFields } from './PlanSection'
import { BlockRenderer } from '../../../renderer/contentful/BlockRenderer'

type ProductDetailsProps = {
  sectionDetail: PlanSectionDetailFields
  IMAGE_LEFT_MARGIN: number
}

const ProductDetailsSection = ({ sectionDetail, IMAGE_LEFT_MARGIN }: ProductDetailsProps) => {
  return (
    <>
      {sectionDetail.headingIcon && (
        <Box>
          <div style={{ display: 'flex' }}>
            <Positioned icon>
              <BlockRenderer block={sectionDetail.headingIcon} />
            </Positioned>
            <Spacer space={3} direction="row" />
            <div>
              <div style={{ display: 'flex' }}>
                {sectionDetail.headingText && (
                  <Typography variant={{ size: 'h4' }}>
                    <LegalTextRenderer>{sectionDetail.headingText}</LegalTextRenderer>
                  </Typography>
                )}
                {sectionDetail.tooltipText && (
                  <>
                    <Spacer space={2} direction="row" />
                    <Positioned tooltip>
                      <Tooltip content={sectionDetail.tooltipText} />
                    </Positioned>
                  </>
                )}
              </div>
              <div style={{ display: 'block' }}>
                <Typography>
                  <LegalTextRenderer>{sectionDetail.descriptionText}</LegalTextRenderer>
                </Typography>
                <Spacer space={2} />
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginLeft: `${IMAGE_LEFT_MARGIN}px` }}>
            {sectionDetail.images &&
              sectionDetail.images.map((image, idx) => {
                let margin = 16
                if (idx == sectionDetail.images.length - 1) {
                  margin = 8
                }
                return (
                  <div style={{ marginRight: `${margin}px` }} key={idx}>
                    <BlockRenderer block={image} />
                  </div>
                )
              })}
            {<BlockRenderer block={sectionDetail.textLink} />}
          </div>
        </Box>
      )}

      <Box>
        <Spacer space={2} />
        {!sectionDetail.headingIcon && (
          <ul style={{ listStylePosition: 'outside', paddingLeft: '24px', paddingBottom: '0px', margin: '0px' }}>
            <li style={{ margin: '0px' }}>
              <span style={{ position: 'relative', left: '8px' }}>
                <Typography>
                  <LegalTextRenderer>{sectionDetail.descriptionText}</LegalTextRenderer>
                </Typography>
              </span>
            </li>
          </ul>
        )}
      </Box>
    </>
  )
}

export default ProductDetailsSection
